import { defineMessages } from 'react-intl';

export default defineMessages({
    cancelPromptTitle: {
        id: 'ml.rewrite.common.config.Are you sure you want to cancel?',
        defaultMessage: 'Are you sure you want to cancel?'
    },
    cancelPrompt: {
        id: 'rewrite.common.config.Are you sure you want to withdraw this rewrite?',
        defaultMessage: 'Are you sure you want to withdraw this rewrite?'
    },
    genericErrorMessage: {
        id: 'rewrite.common.config.Something went wrong during this process.',
        defaultMessage: 'Something went wrong during this process.'
    },
    genericErrorTitle: {
        id: 'rewrite.common.config.Error',
        defaultMessage: 'Error'
    },
    retrieving: {
        id: 'rewrite.common.config.Loading rewrite',
        defaultMessage: 'Loading rewrite'
    },
    errorRetrievingTitle: {
        id: 'rewrite.common.config.Unable to load rewrite',
        defaultMessage: 'Unable to load rewrite'
    },
    errorRetrievingMessage: {
        id: 'rewrite.common.config.An error occurred while loading the rewrite',
        defaultMessage: 'An error occurred while loading the rewrite'
    },
    withdrawErrorMessage: {
        id: 'rewrite.common.config.An error occurred while attempting to withdraw the rewrite',
        defaultMessage: 'An error occurred while attempting to withdraw the rewrite'
    },
    withdrawErrorTitle: {
        id: 'rewrite.common.config.Unable to withdraw rewrite',
        defaultMessage: 'Unable to withdraw rewrite'
    },
    selectEffectiveDate: {
        id: 'rewrite.wizard.step.Select Effective Date',
        defaultMessage: 'Select Effective Date'
    },
    rewritePolicy: {
        id: 'rewrite.wizard.step.Rewrite Policy',
        defaultMessage: 'Rewrite Policy'
    },
    coverages: {
        id: 'rewrite.wizard.step.Coverages',
        defaultMessage: 'Coverages'
    },
    verbalAuthorization: {
        id: 'rewrite.wizard.step.Verbal authorization',
        defaultMessage: 'Verbal authorization'
    },
    agentSignature: {
        id: 'rewrite.wizard.step.Agent Signature',
        defaultMessage: 'Agent Signature'
    },
    requiredSignatures: {
        id: 'rewrite.wizard.step.Required Signatures',
        defaultMessage: 'Required Signatures'
    },
    availableDocuments: {
        id: 'rewrite.wizard.step.Available Documents',
        defaultMessage: 'Available Documents'
    },
    withdrawing: {
        id: 'rewrite.wizard.step.Completed Changes',
        defaultMessage: 'Completed Changes'
    },
    policyRewriteConfirmation: {
        id: 'rewrite.wizard.step.Policy Rewrite Confirmation',
        defaultMessage: 'Policy Rewrite Confirmation'
    },
});